export class MicrosoftEntityDeleteRequest{
    public customerId!:number;
    public clientId!:number;
}
